export const GET_PACKAGES = 'packages/getPackages';
export const GET_INITIAL_PACKAGES = 'packages/getInitialPackages';

export const GET_OWNED_PACKAGE = 'packages/getOwnedPackage';

export const actionTypes = {
  GET_PACKAGES,
  GET_OWNED_PACKAGE,
  GET_INITIAL_PACKAGES,
};
